export default "__VITE_ASSET__CheU8MdQ__"